import * as accountinfo from '../actionTypes/Accounts/AccountInfo'
import Api from '../Api'
import { Config } from '../Config'
import { CommonConstants } from '../Constants'
import AuthenticationService from '../components/Security/AuthenticationService'
import requestIp from 'ip'
var _ = require('underscore')

// This function returns Get Account Action Success
function GetAccountSuccess (accountDetails) {
  return {
    type: accountinfo.GET_ACCOUNT,
    accountDetails
  }
}

// This function returns Update Account Action Success
function UpdateAccountSuccess (accountDetails) {
  return {
    type: accountinfo.UPDATE_ACCOUNT,
    accountDetails
  }
}

// This function using call Get AccountInfo api and return the results
export const GetAccountInfo = () => {
  let url = Config.apiBaseUrl + CommonConstants.apiUrls.getAccountInfo
  return (dispatch, getState) => {
    const api = new Api()
    api.getData(url, data => {
      let accountsData = data
      dispatch(GetAccountSuccess(accountsData))
    })
  }
}

// This function using call Update Account Info api and return the results
export const UpdateAccountInfo = (data, callback) => {
  return (dispatch, getState) => {
    if (data.currentPassword !== undefined && !_.isEmpty(data.currentPassword)) {
      changePassword(data, result => {
        if (!result.validPassword) {
          let accountsData = data
          dispatch(UpdateAccountSuccess(accountsData))
          callback(result)
        } else {
          accountAgreeTOS(data, result => {
            if (result.status) {
              saveAccountInfo(data, result => {
                let accountsData = data
                dispatch(UpdateAccountSuccess(accountsData))
                callback(result)
              })
            }
          })
        }
      })
    } else {
      accountAgreeTOS(data, result => {
        if (result.status) {
          saveAccountInfo(data, result => {
            let accountsData = data
            dispatch(UpdateAccountSuccess(accountsData))
            callback(result)
          })
        }
      })
    }
  }
}

// This function using call save Account Info api and return the results
const saveAccountInfo = function (data, callback) {
  const api = new Api()
  let url = Config.apiBaseUrl + CommonConstants.apiUrls.saveAccountInfo
  /// data['changeEmail'] = data.userEmail
  api.postData(url, data, result => {
    if (result.status) {
      if (data.resetPassword === 1) {
        data.resetPassword = 0
      }
      if (data.AccountTOSAgree === null || data.AccountTOSAgree === 0) {
        newTokenGeneration(data, callback)
      } else {
        callback(result)
      }
    } else {
      callback(result)
    }
  })
}

// This function using call change Password api and return the results
const changePassword = function (data, callback) {
  const api = new Api()
  let url = Config.apiBaseUrl + CommonConstants.apiUrls.verifycredential
  let datapassvalidate = {
    uuId: data.uuId,
    password: data.currentPassword
  }
  api.postData(url, datapassvalidate, callback)
}

// This function using call account Agree TOS api and return the results
const accountAgreeTOS = function (data, callback) {
  const api = new Api()
  let url = Config.apiBaseUrl + CommonConstants.apiUrls.agreeAccountTOS
  let agreedata = {
    uuId: data.uuId,
    UserID: data.UserID,
    AccountTOSBrowser: navigator.userAgent,
    AccountTOSIP: requestIp.address(),
    ownerAccountId: data.ownerAccountId,
    AccountTOSAgree: 1
  }
  api.postData(url, agreedata, callback)
}

// This function using call  Token Generation api and return the results
const newTokenGeneration = function (data, callback) {
  const authService = new AuthenticationService(Config.authBaseUrl)
  const api = new Api()
  let user = {
    username: data.userEmail.trim(),
    password: data.newPassword
  }
  let url = Config.authBaseUrl + Config.tokenPath
  authService.clearAgreedAccount()
  api.postData(url, user, result => {
    authService.setToken(result.accessToken, 0)
    var output = { status: true, key: 'success' }
    callback(output)
  })
}

// This function using call  Get Account api using UID and return the results
export const GetAccountByUid = (callback) => {
  const api = new Api()
  const authService = new AuthenticationService(Config.authBaseUrl)
  let url = Config.apiBaseUrl + CommonConstants.apiUrls.getAdminAcount + '?uuid=' + authService.getUUID()
  api.getData(url, data => {
    callback(data)
  })
}



// WEBPACK FOOTER //
// ./src/actions/account.js